module.exports = __webpack_public_path__ + "img/Patch23-5.8896506e.webp";